import { useTranslation } from "react-i18next";
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import CreateIcon from '@material-ui/icons/Create';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';

import './form.css'
import emailjs from 'emailjs-com';

import { BrowserRouter as Router, Link } from "react-router-dom";
import Skeleton from '@mui/material/Skeleton';
import React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import 'semantic-ui-css/semantic.min.css';
import { Form, Input, TextArea, Button } from 'semantic-ui-react';
import Swal from 'sweetalert2';
import { fontSize } from "@mui/system";
import '../../assets/scss/button-send.scss'
import { motion } from 'framer-motion/dist/framer-motion'

const useStyles = makeStyles((theme) => ({ 
  projects: {
    paddingTop: "180px",  
    "@media (max-width: 550px)": {
      paddingTop: "160px", 
    },  
  },
  title: {
    textAlign: 'center',
    textShadow: '1px 1px 1px black',
    color: 'white',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    borderRadius: '50px',
    height: '100px',
    marginBottom: '72px',

    "@media (max-width: 550px)": {
      fontSize: '29px',
      marginLeft: "10px",
      marginRight: "10px",
      height: '70px'
    },
  },
  switch: {
    transform: 'scale(1.2)'
  },
  stepperdark: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    marginLeft:'7%',
    borderRadius: '13px',
    border: '3px solid rgba(0, 0, 0, 0.6)'
    
  },
  stepperlight: {
    backgroundColor: 'rgba(29, 207, 252, 0.7)',
    marginLeft:'7%',
    borderRadius: '13px',
    border: '3px solid rgba(0, 153, 255, 0.6)'
    
  }
}));




const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient( 95deg,rgb(255, 155, 23) 0%,rgb(233,64,87) 50%,rgb(255, 123, 0, 0.6) 100%)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient( 95deg,rgb(255, 155, 23) 0%,rgb(233,64,87) 50%,rgb(255, 123, 0, 0.6) 100%)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...(ownerState.active && {
    backgroundImage:
      'linear-gradient( 136deg, rgb(242,153,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    backgroundImage:
      'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <CreateIcon />,
    2: <DoneOutlineIcon />,
    3: <ForwardToInboxIcon />,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

export default function Forms(props) {

    const { t } = useTranslation();

    const classes = useStyles();


    // const steps = [{t('write')}, [{t('write_message')}, [{t('write_message')}];


    const SERVICE_ID = "service_49rx8iz";
    const TEMPLATE_ID = "template_2z42oqj";
    const USER_ID = "user_w4Y6DPg0KsRKsSlZsPNoO";


    const handleOnSubmit = (e) => {
      e.preventDefault();
      handleNext()
      emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, e.target, USER_ID)
        .then((result) => {
          console.log(result.text);
          
          Swal.fire({
            icon: 'success',
            title: '📩'
          })
          
        }, (error) => {
          console.log(error.text);
          Swal.fire({
            icon: 'error',
            title: '📦',
            text: error.text,
          })
        });
        setTimeout(() => {
          handleNext()
        }, 2000);
        setTimeout(() => {
          handleReset()
        }, 6000);
      e.target.reset()
      
      }


      //Stepper

      const [activeStep, setActiveStep] = React.useState(0);

               
      
        const handleNext = () => {                
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
        };
      
      
            
        const handleReset = () => {
          setActiveStep(0);
        };
      

        

    return(
      <>
      <motion.div
                  initial={{ opacity: 0, y: -180}}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                      ease: "easeInOut",
                      duration: 1,
                      delay:0.3
                  }}
                  >
        <Container maxWidth="md" className={classes.projects}>
            
            
            <Typography variant="h3" align="center" paragraph className={classes.title}>
                <b><u>{t('form')}</u></b><br/>
                <Typography variant="h6" align='center'>{t('send_me')} 📩</Typography>
                </Typography>


      


            
                <div className='contactform' >
                  <Form onSubmit={handleOnSubmit} className={props.darkMode ? 'formdark' : 'formlight'}>
                    <Form.Field
                      id='form-input-control-email'
                      control={Input}
                      label={t('email')}
                      name='user_email'
                      placeholder={t('email')}
                      required
                      icon='mail'
                      iconPosition='left'
                      className="formfield"
                    />
                    <Form.Field
                      id='form-input-control-last-name'
                      control={Input}
                      label={t('name')}
                      name='user_name'
                      placeholder={t('name')}
                      required
                      icon='user circle'
                      iconPosition='left'
                      className="formfield"
                    />
                    <Form.Field
                      id='form-textarea-control-opinion'
                      control={TextArea}
                      label={t('message')}
                      name='user_message'
                      
                      className="formfield"

                      required
                    />
                    <button type='submit' className="button">{t('submit')}</button>

                    {/* <Button type='submit' color='green'>{t('submit')}</Button> */}
                  </Form>
                </div>





     <Box sx={{ width: '88%' }} className={props.darkMode ? classes.stepperdark : classes.stepperlight}>
      <Stepper activeStep={activeStep} alternativeLabel connector={<ColorlibConnector />} style={{marginTop:'10px', marginBottom:'10px'}}>
        
          
        
            <Step>
              <StepLabel  StepIconComponent={ColorlibStepIcon} >{t('write_stepper')}</StepLabel>
            </Step>
            <Step   >
              <StepLabel  StepIconComponent={ColorlibStepIcon} >{t('submit_stepper')}</StepLabel>
            </Step>
            <Step >
              <StepLabel  StepIconComponent={ColorlibStepIcon} >{t('send_stepper')}</StepLabel>
            </Step>
          
      
      </Stepper>
      
    </Box>
        </Container>
        </motion.div></>
    )

}